import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { toHtml, RenderMode } from 'silk-renderer';
import { Observable } from 'rxjs/Observable';
import { BuyerToSellerService } from '../buyer-to-seller.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationService } from 'app/core/services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { ISOToDatePipe } from 'app/shared/pipes/iso-to-date.pipe';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
  selector: 'itpx-seller-terms-and-conditions',
  templateUrl: './seller-terms-and-conditions.component.html',
  styleUrls: ['./seller-terms-and-conditions.component.css']
})
export class SellerTermsAndConditionsComponent extends RxComponent implements OnInit {
  @Input() id: string;
  @Input() isAuthorizedSignatory: boolean;
  @Input() proceed: Observable<string>;
  @Input() signatoryList: any[];
  @Input() isPublic: boolean;
  @Output() enableNextStep$ = new EventEmitter<boolean>();
  @Output() canProceed = new EventEmitter<boolean>();

  private terms$: Observable<any>;
  private terms: any;
  private form: FormGroup;
  private authorizedSignatoryList: { key: any; value: string; }[];
  userId: any;


  constructor(
    private fb: FormBuilder,
    private service: BuyerToSellerService,
    private notificationService: NotificationService,
    private route: ActivatedRoute
  ) {
    super();
   }

  ngOnInit() {

    this.terms$ = this.service.getTermsAndConditions()
      .map(data => toHtml(JSON.parse(data.content), { renderMode: RenderMode.REPLACE, extras: {} }));

    this.terms$.subscribe(data => this.terms = data);
    this.form = this.fb.group({
      confirmPolicy: [false, this.isAuthorizedSignatory ? Validators.required : Validators.nullValidator],
      authorizedSignatory: [null, this.isAuthorizedSignatory ? Validators.nullValidator : Validators.required]
    });

    this.authorizedSignatoryList = this.signatoryList.map(item => ({
      key: item.email,
      value: `${item.firstName} ${item.lastName} (${item.email})` // + this.extractNotification(item)
    }));

    this.form.valueChanges.subscribe(state => this.enableNextStep$.emit(this.isAuthorizedSignatory ? state.confirmPolicy : this.form.valid));
    if (1 === this.authorizedSignatoryList.length) {
      this.form.get('authorizedSignatory').setValue(this.authorizedSignatoryList[0].key);
      this.form.get('authorizedSignatory').disable();
    }

    if (this.isAuthorizedSignatory && this.isPublic) {
      this.proceed.filter(input => input === this.id)
        .switchMap(_ => this.route.queryParams)
        .switchMap(params => this.service.agreeOnTermsAndConditions(params.id)
          .catchAndEmit('ERROR'))
        .subscribe(res => {
          if ('ERROR' !== res) {
            this.form.get('confirmPolicy').disable();
            this.notificationService.success('buyer.seller.action.complete.success.message');
            this.canProceed.emit(true);
          }
        });
    } else if (this.isAuthorizedSignatory && !this.isPublic) {
      this.proceed.filter(input => input === this.id)
        .switchMap(params => this.service.agreeOnTermsAndConditionsAuthorized()
          .catchAndEmit('ERROR'))
        .subscribe(res => {
          if ('ERROR' !== res) {
            this.form.get('confirmPolicy').disable();
            this.notificationService.success('buyer.seller.action.complete.success.message');
            this.canProceed.emit(true);
          }
        });
    } else if (!this.isAuthorizedSignatory && !this.isPublic) {
      this.proceed.filter(input => input === this.id).switchMap(_ =>
        this.service.notify(this.signatoryList.find(signatory => signatory.email === this.form.get('authorizedSignatory').value))
          .catchAndEmit({ data: null, error: true }))
        .subscribe(res => {
          if (res.data) {
            if (res.data.id) {
              this.notificationService.success('buyer.seller.signatory.notification.sent');
              this.canProceed.emit(true);
            } else {
              const response = res.data;
              Observable.zip(this.service.getEmployeeData(response.employeeEmail),
                this.service.getEmployeeData(response.authorizedSignatoryEmail))
                .bindToLifecycle(this)
                .subscribe(([employee, signatory]) => {
                  let notificationSentMessage = `User ${employee.firstName} ${employee.lastName} has sent an invitation to ` +
                    `${signatory.firstName} ${signatory.lastName} on ${this.service.formatDate(response.createdAt)}`;
                  this.notificationService.alert(notificationSentMessage);
                  this.canProceed.emit(true);
                });
            }
          }
        });
    } else {
      throw new Error('Incorrect setup!')
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/buyer-to-seller/seller-terms-and-conditions/seller-terms-and-conditions.component.ts